var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.suggestions.length > 0),expression:"suggestions.length > 0"}],staticClass:"largeText border",style:({
  position: 'fixed',
  left: _vm.left + 'px',
  top: _vm.top + 'px',
  minWidth: _vm.width + 'px',
  zIndex: 110,
  backgroundColor: 'white',
})},[_c('div',{staticClass:"divTable"},[_c('div',{staticClass:"divTableBody"},_vm._l((_vm.suggestions),function(item){return _c('div',{staticClass:"divTableRow",on:{"click":function($event){return _vm.update(item)}}},[_c('span',{staticClass:"divTableCell left"},[_vm._v(_vm._s(((item.forename) + " " + (item.surname) + " <" + (item.username) + ">")))])])}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }